import { takeLatest } from 'redux-saga';
import { call, put,select,cancelled } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import { toast } from 'react-toastify';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import request from 'utils/request';

import {
  requestServicesSuccess,
  fetchPlaidLinkTokenSuccess,
  dentistSpecialtiesSuccess,
  fetchAssociationsSuccess,
  pricingCodesSuccess,
  submitSFLeadFormSuccess
} from './actions';

import {
  SERVICES_REQUEST_ATTEMPT,
  SERVICES_REQUEST,
  FETCH_PLAID_LINK_TOKEN,
  DENTIST_SPECIALTIES_ATTEMPT,
  DENTIST_SPECIALTIES_REQUEST,
  PRICING_CODES_REQUEST,
  PRICING_CODES_ATTEMPT,
  LEAD_TO_SF_REQUEST,
  TERMS_OFF,
  ANNOUNCEMENT_OFF,
  RETRY_PAYMENT,
  FETCH_ASSOCIATIONS_REQUEST,
  FETCH_ASSOCIATIONS_ATTEMPT,
  FETCH_ASSOCIATIONS_ERROR,
  ENVELOPE_ID,
  TURN_ON_UPGRADE_REQUEST,
  TOGGLE_SMS_OFFICE,
} from './constants';

import {
  selectFetchingAssociations,
  selectFetchingPricingCodes,
  selectFetchingServices,
  selectFetchingSpecialties
} from './selectors'

function* requestServices () {
  yield* takeLatest(SERVICES_REQUEST, function* handler () {
    try {
      let assoc=yield select(selectFetchingServices)
        // making sure that this isn't called multiple times
        if(assoc==false){
          yield put({
            type: SERVICES_REQUEST_ATTEMPT,
          });
      const services = yield call(request, '/api/v1/services');
      yield put(requestServicesSuccess(services));
        }
    } catch (e) {
      console.log(e);
    }
  });
}

function* submitLeadToSF () {
  yield* takeLatest(LEAD_TO_SF_REQUEST, function* handler ({payload}) {
    try {
      const services = yield call(request, '/api/v1/salesforce-connect/addSFLead',{method:'POST',body: JSON.stringify(payload)});
      yield put(submitSFLeadFormSuccess(services));
    } catch (e) {
      console.log(e);
    }
  });
}

function* toastRemover () {
  yield* takeLatest(LOCATION_CHANGE, function* handler () {
    toast.clearWaitingQueue();
  });
}

function* requestPlaidLinkToken (){
  yield* takeLatest(FETCH_PLAID_LINK_TOKEN, function* handler () {
    try {
      const data = yield call(request, '/api/v1/stripe-connect/createPlaidLinkToken',{ method: 'POST'});
       yield put(fetchPlaidLinkTokenSuccess(data));
    } catch (e) {
      console.log(e);
    }
  });
}

function* fetchDentistSpecialties () {
  yield* takeLatest(DENTIST_SPECIALTIES_REQUEST, function* handler () {
    try {
      let assoc=yield select(selectFetchingSpecialties)
      // making sure that this isn't called multiple times
      if(assoc==false){
        yield put({
          type: DENTIST_SPECIALTIES_ATTEMPT,
        });
      const response = yield call(request, '/api/v1/dentist-specialties');
      yield put(dentistSpecialtiesSuccess(response.data));
      }
    } catch (e) {
      console.log(e);
    }
  });
}



function* termsOffWatcher() {
  while (true) {
    yield takeLatest(TERMS_OFF, function* handler(action) {
    const { dentistInfoId,dentist_type } = action;
    const params = {   method: "POST",  };
    const response = yield call(request, `/api/v1/accounts/terms-accepted/${dentistInfoId}/${dentist_type}`,params);
    });
  }
}


function* retryPaymentRequest () {
  yield* takeLatest(RETRY_PAYMENT, function* handler({userId}) {
    try {
      var params = {
        method: 'POST',
        body: JSON.stringify({userId:userId}),
      };
      const response = yield call(request, `/api/v1/users/me/update-account/retryPayment`,params);
      (toast.success( 'Retry payment was successful'));
      setTimeout(function() {   window.top.location.reload();   }, 5000);
    } catch (error) {
      (toast.error( `${error.error}`));
    }
  });
}

function* fetchPricingCodes() {
  yield* takeLatest(PRICING_CODES_REQUEST, function* handler() {
    try {
    let assoc=yield select(selectFetchingPricingCodes)
        // making sure that this isn't called multiple times
        if(assoc==false){
          yield put({
            type: PRICING_CODES_ATTEMPT,
          });
        const response = yield call(request, '/api/v1/pricing');
        yield put(pricingCodesSuccess(response.data));
      }
    } catch (e) {
      console.log(e);
    }
  });
}

// associations
function* associationsFetcher() {
    yield* takeLatest(FETCH_ASSOCIATIONS_REQUEST, function* handler() {
      try {
        let assoc1=yield select(selectFetchingAssociations)
        // making sure that this isn't called multiple times
        if(assoc1==false){
          yield put({
            type: FETCH_ASSOCIATIONS_ATTEMPT,
          });
          const associations = yield call(request, '/api/v1/associations/list', {
            method: "POST",
          });
          yield put(fetchAssociationsSuccess(associations));

        }
      } catch (e) {
        console.log(e)
        yield put({ type: FETCH_ASSOCIATIONS_ERROR });
      }
    });
}

function* postEnvelopeId() {
  while (true) {
    // listen for the DENTIST_SIGNUP_REQUEST action dispatched on form submit
    try {
      yield takeLatest(ENVELOPE_ID, function* handler(action) {
        if(action.envelopeId!=null){
          var params = {
            method: 'POST',
            body: JSON.stringify(action),
          };
          let response = {};

          if (action.dentistInfoId == null) {
            response = yield call(
              request,
              `/api/v1/accounts/envelope?envelopeId=${action.envelopeId}`,
              );
          } else {
            response = yield call(request, `/api/v1/accounts/envelope`, params);

            cookies.set('baaYes', 'accepted', { path: '/' });

            if(response.reload) {
              setTimeout(function () {
                window.top.location.reload();
              }, 5000);
            }          
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
}

function* turnOnUpgrade() {
  yield* takeLatest(TURN_ON_UPGRADE_REQUEST, function* handler(payload) {
    try {
      const response = yield call(request, `/api/v1/dentists/turnOnUpgrade`, {
        method: 'POST',
        body: JSON.stringify({ dentistInfoId: payload.dentistInfoId })
      });
      if(payload.toast==true){
       (toast.success( 'Office Upgrade Turned On'));
      }
    } catch (error) {
      console.log(error);
      (toast.error('Office Upgrade not working'));
    }
  });
}

function* SMSToggleFetcher() {
  while (true) {
    yield takeLatest( TOGGLE_SMS_OFFICE, function* handler(action) {
      const params = { method: "POST", body: JSON.stringify(action) };
      const response = yield call(request, `/api/v1/dentists/smsToggle`, params);
      (toast.success( response._message));

      //setTimeout(() => window.location.reload(), 500);
    })
  }
}
  
function* announcementOffWatcher() {
  while (true) {
    yield takeLatest(ANNOUNCEMENT_OFF, function* handler(action) {
    const { userId } = action;
    const params = {   method: "POST",  };
    const response = yield call(request, `/api/v1/accounts/user-terms-accepted/${userId}`,params);
    });
  }
}


export default [
  requestServices,
  toastRemover,
  requestPlaidLinkToken,
  fetchDentistSpecialties,
  fetchPricingCodes,
  submitLeadToSF,
  termsOffWatcher,
  retryPaymentRequest,
  associationsFetcher,
  postEnvelopeId,
  turnOnUpgrade,
  SMSToggleFetcher,
  announcementOffWatcher
];
